import React, { FC, useState, useEffect } from 'react'
import ImgScalerIcon from '../../../../assets/images/img_scaler.svg'
import CloseIcon from '../../../../assets/images/close_x_btn.svg'
import ImageGallery from 'react-image-gallery'

interface ISmallGallery {
    heading: string
    images: string[]
}

const SmallGallery: FC<ISmallGallery> = ({ heading, images }) => {
  const [isScaled, setIsScaled] = useState(false)
  const [isShowAll, setIsShowAll] = useState(false)

  const scaledImages = images.map((image_url, index) => ({ original: image_url, originalAlt: `Photo ${index + 1}` }))

  const galleryRef = React.createRef<ImageGallery>()
  useEffect(() => { galleryRef.current?.fullScreen() }, [isScaled])

  return (
    <>
        <h3>{heading}</h3>
        <div className='mt-3 d-flex column-gap-5 row-gap-3 align-items-center justify-content-center flex-wrap'>
            {(isShowAll ? images : images.slice(0, 3)).map((image_url) => (
                    <div className='position-relative'>
                        <img className='object-fit-cover rounded' width='200px' height='200px' src={image_url} alt={ heading + ' item' } />
                        <div className='position-absolute end-0 top-0' onClick={() => setIsScaled(true)}>
                            <img src={ImgScalerIcon} alt="Scale" />
                        </div>
                    </div>
            ))}
            {isScaled &&
                <ImageGallery
                    ref={galleryRef}
                    items={scaledImages}
                    useBrowserFullscreen={false}
                    showFullscreenButton={false}
                    showPlayButton={false}
                    renderCustomControls={() =>
                        <div className='d-flex justify-content-end px-4'>
                            <div onClick={() => setIsScaled(false)} className='close_fullscreen ms-auto'>
                                <img width='32px' height='32px' src={CloseIcon} alt="Close" />
                            </div>
                        </div>
                    }
                />
            }
        </div>
        <div className='actions'>
            <button type='button' className='w-100 mt-4 main_submit' onClick={() => setIsShowAll(!isShowAll)}>
                {isShowAll ? 'Свернуть' : 'Показать все'}
            </button>
        </div>
    </>
  )
}

export default SmallGallery
